<div [ngClass]="{'col-12 col-xl-6' : !allSettings}">
    <div class="card">
        <div class="card-header">
            <h5 class="card-title">{{"fw_update" | translate}}</h5>
        </div>
        <div class="card-body">
            <form>
                <div class="form-group row">
                    <div class="col-8">
                        <strong>{{"versionDevice" | translate}}</strong>
                    </div>
                    <div class="col-4">
                        {{device?.firmware_version_name}}
                    </div>
                </div>
                <div class="form-group row" *ngIf="availableNewVersion">
                    <p class="text-grey">{{"newVersionAv" | translate}}</p>
                    <strong class="text-center">
                        {{latestVersion?.name}}
                    </strong>
                </div>
                <div class="form-group row" *ngIf="!availableNewVersion">
                    <p class="text-grey">{{"isLastVersion" | translate}}</p> 

                </div>

                <div class="form-group row">
                    <div class="col-sm-4 m-auto text-center">
                        <button type="button" class="btn btn-primary" (click)="update()"
                            [disabled]="!availableNewVersion || cortex?.blockEsp32Update">{{"do_update" | translate}}</button>
                        <p class="small text-warning mt-2 mb-0" *ngIf="cortex?.blockEsp32Update">
                            <i class="fas fa-lock me-1"></i>
                            {{ (cortex?.updateInProgress ? 'cortexBlockInProgress' : 'cortexFirst') | translate }}
                        </p>
                    </div>
                </div>
            </form>

            <ng-container *ngIf="cortex">
                <hr>
                <h6 class="card-subtitle mb-3">{{"cortexUpdateTitle" | translate}}</h6>

                <div class="data-item mb-3">
                    <div class="data-icon bg-primary bg-opacity-10">
                        <i class="fas fa-microchip text-primary"></i>
                    </div>
                    <div class="data-content">
                        <div class="data-value">{{cortex.currentVersion || '-'}}</div>
                        <small class="data-label" *ngIf="cortex.model">{{cortex.model}}</small>
                    </div>
                </div>

                <div class="form-group row" *ngIf="cortex.available">
                    <p class="text-grey mb-1">{{"cortexNewVersionAv" | translate}}</p>
                    <strong class="text-center">{{cortex.available.name}}</strong>
                </div>
                <div class="form-group row" *ngIf="!cortex.available">
                    <p class="text-grey">{{"cortexIsLastVersion" | translate}}</p>
                </div>
                <div class="form-group row" *ngIf="cortex.available && !cortexUpdating">
                    <div class="col-sm-6 m-auto text-center">
                        <button type="button" class="btn btn-primary" (click)="updateCortex()">{{"cortexUpdate" | translate}}</button>
                    </div>
                </div>

                <div *ngIf="cortexUpdating">
                    <div class="progress mb-3">
                        <div class="progress-bar progress-bar-striped progress-bar-animated w-100" role="progressbar"></div>
                    </div>
                    <ul class="list-group list-group-flush mb-3">
                        <li class="list-group-item d-flex align-items-center" *ngFor="let step of visibleCortexSteps">
                            <i class="fas fa-check text-success me-2" *ngIf="step.reached"></i>
                            <span class="spinner-border spinner-border-sm text-primary me-2" *ngIf="step.active"></span>
                            <i class="far fa-circle text-muted me-2" *ngIf="!step.reached && !step.active"></i>
                            {{ step.label | translate }}
                        </li>
                    </ul>
                </div>

                <div class="alert alert-success" role="alert" *ngIf="cortexStep === 'done'">
                    <div class="alert-message">
                        {{"cortexUpdateDone" | translate}}
                        <span *ngIf="cortexMessage"> {{cortexMessage}}</span>
                        <small class="d-block text-muted" *ngIf="cortexTimestamp">{{cortexTimestamp | date:'short'}}</small>
                    </div>
                </div>
                <div class="alert alert-danger" role="alert" *ngIf="cortexStep === 'failed'">
                    <div class="alert-message">
                        {{"cortexUpdateFailed" | translate}}
                        <span *ngIf="cortexMessage"> — {{"cortexCause" | translate}}: {{cortexMessage}}</span>
                        <small class="d-block text-muted" *ngIf="cortexTimestamp">{{cortexTimestamp | date:'short'}}</small>
                    </div>
                </div>
                <div class="alert alert-warning" role="alert" *ngIf="cortexStep === 'timeout'">
                    <div class="alert-message">{{"cortexUpdateTimeout" | translate}}</div>
                </div>
                <div class="alert alert-danger" role="alert" *ngIf="cortexError">
                    <div class="alert-message">{{cortexError}}</div>
                </div>
            </ng-container>

            <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="error!=''">
                <div class="alert-message">
                    {{ error }}
                </div>
            </div>
            <div class="alert alert-success alert-dismissible" role="alert" *ngIf="successMessage">
                <div class="alert-message">
                    {{"fwUpdateOrderSent" | translate}}
                </div>
            </div>
        </div>
    </div>
</div>
